import { Component } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { SessionService } from '../services/session.service';

@Component({
    selector: 'image-upload',
    templateUrl: './image-upload.component.html',
    styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent {

    imageState: 'noImage' | 'uploaded' | 'waitingForConfirmation' | 'confirmed' | 'notConfirmed' | 'error' = 'noImage'

    constructor(protected sessionService: SessionService) { }

    title = 'ngImageCrop';
    imageChangedEvent: any;

    fileChangeEvent(event: any): void {
        this.imageState = 'uploaded';
        this.imageChangedEvent = event;
    }

    imageCropped(event: ImageCroppedEvent) {
        this.sessionService.croppedImage = event.base64;
    }

    imageLoaded() {
        /* show cropper */
    }

    cropperReady() {
        /* cropper ready */
    }

    loadImageFailed() {
        this.imageState = 'error';
    }

    changeSection(): void {
        this.imageState = 'uploaded';
    }

    async confirmImage(): Promise<void> {
        this.imageState = 'waitingForConfirmation';
        this.imageState = await this.sessionService.imageFaceDetectionOnServer() ? 'confirmed' : 'notConfirmed';
    }
}
